<template>
  <div class="nettdoc-number-input">
    <label v-if="showLabel" :style="(model !== null && model !== '') || labelVisible ? 'visibility:visible' : 'visibility:hidden'" for="input-field" class="nettdoc-number-input__toplabel">{{ $t(label) }}</label>
    <div class="nettdoc-number-input__input">
      <input
        :type="textInput ? 'text' : 'number'"
        id="input-field"
        :placeholder="$t(label)"
        :value="model"
        @change="e => {$emit('action', e.target.value); doChange(e.target.value)}"
      />
      <span v-if="model && (model >= 0 || model.length > 0) && !hideClose">
        <img
          @click="() => $emit('action', null)"
          class="nettdoc-number-input__input-delete"
          src="../assets/icon-basis-ic-close.svg"
        />
      </span>
    </div>
  </div>
</template>

<script>
import { observer } from "mobx-vue";

export default observer({
  name: "NumberInput",
  data() {
    return {
      labelVisible: false,
      inputModel: this.model
    }
  },
  props: {
    label: String,
    model: [Number, String],
    showLabel: Boolean,
    hideClose: Boolean,
    textInput: Boolean
  },
  methods: {
    doChange: function(value) {
      this.inputModel = value
      if (value && value.length > 0) {
        this.labelVisible = true
      } else {
        this.labelVisible = false
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.nettdoc-number-input {
  position: relative;
  padding: 10px 16px;
  &__toplabel {
    text-transform: uppercase;
    color: var(--cool-grey);
    font-weight: bold;
    font-size: 12px;
  }
  &__input {
    position: relative;
  }
  input {
    box-sizing: border-box;
    border: unset;
    border-bottom: 1px solid #cacaca;
    width: 100%;
    padding: 8px 0 2px 0;
    font-weight: 700;
    font-size: 16px;
    &::placeholder {
      color: var(--cool-grey);
    }
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  }
  span {
    position: absolute;
    right: 12px;
    top: 11px;
  }
  &__input-delete {
    width: 12px;
    height: 12px;
    position: absolute;
    cursor: pointer;
  }
}
</style>